import { captureEvent } from '../metrics/captureEvent'

/**
 * Captures submit redirected to thanks
 *
 * @param {'chat' | 'thanks'} target - sent to
 */
export function captureSubmitSentTo(target) {
  captureEvent(`form-sent-to-${target}`)
}
